var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 44,
    viewBox: "0 0 55 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9053 0.221302C27.2597 -0.0737672 26.5181 -0.0737672 25.8725 0.221302L1.42814 11.3959C0.558066 11.7936 0 12.6624 0 13.6191C0 14.5757 0.558066 15.4445 1.42814 15.8422L7.33333 18.5419L12.2222 20.7766L25.8725 27.0167C26.5181 27.3118 27.2597 27.3118 27.9053 27.0167L41.5556 20.7766L46.4444 18.5419L52.3497 15.8422C53.2197 15.4445 53.7778 14.5757 53.7778 13.6191C53.7778 12.6624 53.2197 11.7936 52.3497 11.3959L27.9053 0.221302ZM10.7941 14.7483L8.32392 13.6191L26.8889 5.13222L45.454 13.6191L42.9836 14.7483L26.8889 22.1058L10.7941 14.7483Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4444 32.8702V18.5419L41.5556 20.7766V32.2652C40.358 33.9262 35.9003 39.1111 26.8889 39.1111C17.8775 39.1111 13.4197 33.9262 12.2222 32.2652V20.7766L7.33333 18.5419V32.8702C7.33333 33.3618 7.45678 33.9 7.76808 34.4002C8.57648 35.6992 14.2449 44 26.8889 44C39.533 44 45.2012 35.6992 46.0096 34.4002C46.321 33.9 46.4444 33.3618 46.4444 32.8702Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20.7778C55 22.8028 53.3583 24.4444 51.3333 24.4444C49.3084 24.4444 47.6667 22.8028 47.6667 20.7778C47.6667 18.7528 49.3084 17.1111 51.3333 17.1111C53.3583 17.1111 55 18.7528 55 20.7778Z",
    fill: "#943939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7778 28.1111C53.7778 26.761 52.6834 25.6667 51.3333 25.6667C49.9833 25.6667 48.8889 26.761 48.8889 28.1111V41.5556C48.8889 42.9056 49.9833 44 51.3333 44C52.6834 44 53.7778 42.9056 53.7778 41.5556V28.1111Z",
    fill: "#4860AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradCap);
export default __webpack_public_path__ + "static/media/grad-cap.1b899ff69ca52ee57fe4034c6e2cccc2.svg";
export { ForwardRef as ReactComponent };